module.exports = __webpack_public_path__ + "static/media/15.e0b81b97.svg";